<template>
  <custom-dialog class="check-progamme-dialog" width="1200px" :title="model.title" :visible="visible" v-on="$listeners">
    <div class="dialog-body">
      <div class="content">
        <div class="event-msg">
          <el-form label-position="top">
            <el-row :gutter="20">
              <el-col :span="24">
                <el-form-item :label="$t('dms_check_programme_dialog.shi_jian_dai_ma')">
                  {{ info.eventCode || '-' }}
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="24">
                <el-form-item :label="$t('dms_check_programme_dialog.shi_jian_ming_cheng')">
                  {{ info.eventName || '-' }}
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="24">
                <el-form-item :label="$t('dms_check_programme_dialog.shclfa')" prop="serviceDisposal">
                  <custom-editor v-model="info.serviceDisposal" :height="150" folder="isc/richtext/event" readonly></custom-editor>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="24">
                <el-form-item :label="$t('dms_check_programme_dialog.shclfj')">
                  <t-upload
                    accept="image/*,video/*"
                    type="file"
                    :limit="3"
                    :bizId="info.eventId"
                    bizType="dms.disposal.technician"
                    v-model="info.serviceMediaList"
                    :autoUpload="false"
                    ref="dmsDisposalTechnician"
                    disabled
                  ></t-upload>
                  <span v-if="!info.serviceMediaList || !info.serviceMediaList.length">{{ $t('Common.com_no_data') }}</span>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
        <div class="hmi-msg">
          <el-form label-position="top">
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item :label="$t('dms_check_programme_dialog.shi_jian_dai_maV3')">
                  {{ info.hmiV3Code || '-' }}
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('dms_check_programme_dialog.shi_jian_dai_maV4')">
                  {{ info.hmiV4Code || '-' }}
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="24">
                <el-form-item :label="$t('dms_check_programme_dialog.xian_shi_ming_cheng')">
                  {{ info.hmiName || '-' }}
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="24">
                <el-form-item :label="$t('dms_check_programme_dialog.HMIxian_shi_chu_li')" prop="hmiDisposal">
                  <custom-editor v-model="info.hmiDisposal" :height="150" folder="isc/richtext/event" readonly></custom-editor>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="24">
                <el-form-item :label="$t('dms_check_programme_dialog.HMIfu_jian')">
                  <t-upload
                    accept="image/*,video/*"
                    type="file"
                    :limit="3"
                    :bizId="info.eventId"
                    bizType="dms.disposal.customer"
                    v-model="info.customerMediaList"
                    :autoUpload="false"
                    ref="dmsDisposalCustomer"
                    disabled
                  ></t-upload>
                  <span v-if="!info.customerMediaList || !info.customerMediaList.length">{{ $t('Common.com_no_data') }}</span>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">{{ $t('Common.com_cancel') }}</el-button>
      <el-button type="primary" @click="onConfirm">{{ $t('dms_check_programme_dialog.que_ren') }}</el-button>
    </div>
  </custom-dialog>
</template>

<script>
import tUpload from '@/components/upload.vue';
// import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins';
import customEditor from '@/components/customEditor';

export default {
  mixins: [dialogMixins],
  props: {
    // model: {
    //   data: { eventId }
    // }
  },
  components: { tUpload, customEditor },
  computed: {
    info() {
      return this.model.data || {};
    },
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {
    closeDialog() {
      this.visible = false;
    },

    onConfirm() {},
    init() {},
  },
};
</script>

<style lang="scss">
.check-progamme-dialog {
  .content {
    display: flex;
    .event-msg {
      padding-right: 15px;
      width: 50%;
    }
    .hmi-msg {
      padding-left: 15px;
      border-left: 1px solid rgb(242, 243, 251);
      width: 50%;
    }
  }
}
</style>
